import Vue from 'vue'

const TYPING_TIMER_LENGTH = 2000

Vue.directive('octa-typing', {
  bind(el, binding, vnode) {
    let typingTimeout = null

    let typing = false

    const onTypi = event => {
      if (event.keyCode !== 13) {
        if (!typing) {
          typingTimeout = undefined

          typing = true

          if (vnode.context.onConversation) {
            vnode.context.setTyping('start')
          }
        }

        if (!typingTimeout) {
          typingTimeout = setTimeout(() => {
            if (typing) {
              typing = false

              setTimeout(() => {
                if (!typing) {
                  if (vnode.context.onConversation) {
                    vnode.context.setTyping('stop')
                  }
                }
              }, TYPING_TIMER_LENGTH)
            }
          }, TYPING_TIMER_LENGTH)
        }
      }
    }

    el.addEventListener('keydown', onTypi)
  }
})
